/*************************************************************************
 *
 *  Copyright 2023 Adobe
 *  All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import wasmManifestData from "@ajsprivate/acrobatjs/dist/build/wasm-manifest.json";
import { getQueryParams } from "./queryParseUtils";
import { getVariablesFromQueryParams, preloadAsset } from "./utils";
import { getAjsPath } from "./ajsPathUtils";
import { addFieldsToCommonLogging } from "../logging";
import { isIOS18, isSafari18 } from "./UserAgentsUtils";

export const shouldEnableWasmExceptions = () => {
    const queryParams = getQueryParams();
    const options = getVariablesFromQueryParams(queryParams);

    let shouldEnable = true;
    if (!(WebAssembly && WebAssembly.Exception)) {
        shouldEnable = false;
    } else if (options.ajsExceptionSupport) {
        shouldEnable = options.ajsExceptionSupport === "wasm";
    }
    // TODO: Remove after fix of ADCS-55997
    if (isSafari18() || isIOS18()) {
        shouldEnable = false;
    }
    addFieldsToCommonLogging({ enableWasmExceptions: shouldEnable });
    return shouldEnable;
};


export const preloadSecondaryWasm = () => {
    const secondaryWasmName = wasmManifestData["wasm_acrobat_we.deferred.wasm"];
    const secondaryWasmPath = `${getAjsPath()}build/${secondaryWasmName}`;
    preloadAsset(secondaryWasmPath, "fetch");
};
